import {memo} from 'react';
import {Bounce} from 'react-toastify';
import {StyledContainer} from './styled';

type ProcessToastProps = {
  containerId?: string;
};
const ProcessToast = memo(
  ({containerId}: ProcessToastProps = {containerId: 'process-toast'}) => {
    return (
      <StyledContainer
        position="bottom-right"
        autoClose={5000}
        // autoClose={false}
        limit={5}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        transition={Bounce}
        theme="colored"
        containerId={containerId}
      />
    );
  },
);

export {ProcessToast};
